import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa"; // Importing social icons
import "./../styles/Footer.css";
import logo from "../assets/ssb.png"; // Adjust path based on location

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section: Logo and Address */}
        <div className="footer-column footer-logo-address">
        <img src={logo} alt="Website Logo" className="footer-logo" />
          <p>Hulimavu,</p>
          <p>Bannergatta Road,</p>
          <p>South Bengaluru, Karnataka 560076</p>
        </div>

        {/* Center 1: Our Pages */}
        <div className="footer-column">
          <h4>Our Pages</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/aboutus">About Us</Link></li>
            <li><Link to="/privacypolicy">Privacy Policy</Link></li>
            <li><Link to="/courses">Courses</Link></li>
            <li><Link to="/branches">Branches</Link></li>
            <li><Link to="/contactus">Contact Us</Link></li>
          </ul>
        </div>

        {/* Center 2: Follow Us */}
        <div className="footer-column footer-center">
          <h4>Follow Us</h4>
          <ul className="social-links">
            <li>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <FaFacebookF className="social-icon" /> Facebook
              </a>
            </li>
            <li>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram className="social-icon" /> Instagram
              </a>
            </li>
          </ul>
        </div>

        {/* Right Section: Our Branches */}
        <div className="footer-column footer-right">
          <h4>Our Branches</h4>
          <ul>
            <li><Link to="/branches">Bangalore</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
